import store from "../store";
import { addProcentToTable } from './addProcentToTable';
export const getSelectedTable = () => {
  var table;
  if (store.getters.getVID == 1) {
    table = [...store.getters.get_selected1, ...store.getters.get_selected2];
  }
  if (store.getters.getVID == 2) {
    table = [...store.getters.getPodhodit1, ...store.getters.getPodhodit2];
  }
  return addProcentToTable(table);
};
